import { render, staticRenderFns } from "./indexBar.vue?vue&type=template&id=7a97a770&"
import script from "./indexBar.vue?vue&type=script&lang=js&"
export * from "./indexBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/other/indexBar.vue"
export default component.exports